import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";
import {ReportFormat} from "../state/reportFormat";
import { ConfirmationPopupParams } from "../../components/confirmation-popup/confirmation-popup";
import { PopupType } from "../popups/popupType";

export class ExportBidCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.ExportBid;

    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();
        
        if(!estimate)
            return false;
        
        return true;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(data: { format: ReportFormat }): JQueryPromise<any> {
        let dfd = $.Deferred();

        if (!this.canExecute())
            return dfd.reject().promise();
        console.log(34343434);

        return this.app.popupsManager.show(PopupType.exportBid, true);

        return dfd.promise();
    }

    name = "Export";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/exportBidCommand.ts